export const SITE = {
  name: "SparkIdea Interactive",
  domain: "https://sparkideainteractive.com",
  tagline: "Ideas into products. Products into possibilities.",
  email: "info@sparkidea.in",
  linkedin: "https://www.linkedin.com/in/baltej-singh-46b78112/",
  statement: "An independent venture studio and product engineering partner. We build our own software ventures and help ambitious founders turn ideas into real products.",
  announcement: null,
};

export const FOUNDER = {
  name: "Baltej Singh",
  role: "Founder, SparkIdea Interactive",
  linkedin: "https://www.linkedin.com/in/baltej-singh-46b78112/",
  bio: "Baltej Singh is a technology entrepreneur and software engineer with 16+ years of experience building enterprise-grade applications, SaaS platforms, and digital products. As a multi-time founder, he combines hands-on engineering expertise with product strategy to turn ideas into scalable businesses. Through SparkIdea Interactive, he is building independent software ventures while helping other founders bring their products to life.",
};

export const NAV = [
  {
    label: "Ventures", to: "/ventures",
    items: [
      { label: "All Ventures", to: "/ventures", desc: "The full portfolio" },
      { label: "Nautis", to: "/ventures/nautis", desc: "AI business operating system" },
      { label: "DemoVexa", to: "/ventures/demovexa", desc: "Product demos from code" },
      { label: "Qikod", to: "/ventures/qikod", desc: "AI-assisted software development" },
      { label: "Venture Partnerships", to: "/venture-partnerships", desc: "Co-build with us" },
    ],
  },
  {
    label: "Services", to: "/services",
    items: [
      { label: "Product Discovery & Strategy", to: "/services/product-discovery", desc: "De-risk before you build" },
      { label: "MVP & SaaS Development", to: "/services/mvp-development", desc: "Idea to usable product" },
      { label: "AI Engineering", to: "/services/ai-engineering", desc: "AI that earns its place" },
      { label: "Fractional CTO", to: "/services/fractional-cto", desc: "Senior technical leadership" },
      { label: "Architecture & Cloud", to: "/services/architecture-cloud", desc: "Systems built to evolve" },
      { label: "Product Rescue & Modernization", to: "/services/product-rescue", desc: "Unstick existing products" },
    ],
  },
  {
    label: "How We Build", to: "/how-we-build",
    items: [
      { label: "Our Process", to: "/how-we-build", desc: "From discovery to launch" },
      { label: "Technology & Engineering", to: "/how-we-build#engineering", desc: "How we make technical calls" },
      { label: "Engagement Models", to: "/engagement-models", desc: "Ways to work together" },
    ],
  },
  { label: "About", to: "/about" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

// Data-driven portfolio. Add a record here to publish a new venture everywhere.
export const VENTURES = [
  {
    id: "nautis", slug: "nautis", name: "Nautis", category: "Business software / AI",
    shortDescription: "An AI-powered operating system designed to help founders plan, manage, and grow their businesses.",
    longDescription: "Nautis brings planning, operations, and growth work into one AI-powered workspace for founders and businesses. It is built around a simple idea: running a company should feel like steering with a clear map, not juggling disconnected tools.",
    problem: "Founders juggle strategy, execution, and day-to-day operations across scattered tools, documents, and spreadsheets.",
    audience: "Founders and growing businesses who want one place to plan, manage, and grow.",
    capabilities: ["Business planning with AI assistance", "Operational management in one workspace", "Growth-focused guidance for founders"],
    logo: "/ventures/nautis.png", websiteUrl: "https://getnautis.com", status: "Live",
    featured: true, displayOrder: 1, published: true, accent: "#17B6F4", accent2: "#F98A17",
  },
  {
    id: "demovexa", slug: "demovexa", name: "DemoVexa", category: "Developer tools / Product marketing",
    shortDescription: "Turn software code and product context into polished product demo videos without relying on traditional manual screen recording.",
    longDescription: "DemoVexa generates product demo videos from your code and product context. From code to demo, automatically — so teams can show what they built without hours of manual recording and editing.",
    problem: "Producing product demos is slow, manual, and quickly goes out of date as the product changes.",
    audience: "Software teams, founders, and product marketers who need to show their product clearly.",
    capabilities: ["Demo videos generated from code and product context", "No traditional manual screen recording", "Polished output for product marketing"],
    logo: "/ventures/demovexa.png", websiteUrl: "https://demovexa.com", status: "Live",
    featured: false, displayOrder: 2, published: true, accent: "#7C4DFF", accent2: "#17B6F4",
  },
  {
    id: "qikod", slug: "qikod", name: "Qikod", category: "AI / Software development",
    shortDescription: "An initiative exploring a better way to build software with AI-assisted development workflows.",
    longDescription: "Qikod is SparkIdea's initiative exploring how AI-assisted workflows can make building software faster and more dependable. It is currently in development.",
    problem: "Teams want the speed of AI-assisted development without sacrificing quality, structure, and maintainability.",
    audience: "Developers and teams building software products.",
    capabilities: ["AI-assisted development workflows", "Exploration of better ways to build software"],
    logo: "/ventures/qikod.png", websiteUrl: "https://qikod.com", status: "In Development",
    featured: false, displayOrder: 3, published: true, accent: "#17B6F4", accent2: "#176BFF",
  },
  {
    id: "zingura", slug: "zingura", name: "Zingura", category: "New venture",
    shortDescription: "Our newest venture, currently in development. Details will be shared when it is ready.",
    longDescription: "Zingura is a new SparkIdea Interactive venture currently in development. We'll share more about the problem it solves when it's ready to be introduced.",
    problem: null, audience: null, capabilities: [],
    logo: null, websiteUrl: null, status: "In Development",
    featured: false, displayOrder: 4, published: true, accent: "#F98A17", accent2: "#FFD166",
  },
];

export const publishedVentures = () =>
  VENTURES.filter((v) => v.published).sort((a, b) => a.displayOrder - b.displayOrder);

export const STATUS_STYLE = {
  Live: "bg-emerald-400/10 text-emerald-300 border-emerald-400/30",
  "Early Access": "bg-si-gold/10 text-si-gold border-si-gold/30",
  "In Development": "bg-si-orange/10 text-[#FFB25C] border-si-orange/30",
};
